export default "__VITE_ASSET__DZ$qK2DR__"